import { request } from '../../utils/request';

// 个人中心
export function getUserCenter(params) {
  return new Promise((resolve, reject) => {
    request('/v1/uc/index', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 新个人中心
export function newUserCenter(params) {
  return new Promise((resolve, reject) => {
    request('/v2/user/center', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function bindPhone(params) {
  return new Promise((resolve, reject) => {
    request('/v1/user/bind-mobile', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
